import { useEffect } from 'react'
import type { RefObject } from 'react'
import type { DataSheetGridRef } from 'react-datasheet-grid'
import type { SheetCell } from './useSheetTabs'

/** 표가 그려지면 그 자리에 커서를 놓는다 (마운트 때 한 번) — 단축키로 탭을 옮겨도 키보드로 이어서 편집하게.
 *  열·행 수가 이전 시트보다 적으면 끝 칸으로 */
export function useStartCell(gridRef: RefObject<DataSheetGridRef | null>, cell: SheetCell | null | undefined, cols: number, rows: number) {
  useEffect(() => {
    if (!cell) return
    const id = requestAnimationFrame(() => {
      if (cols > 0 && rows > 0) gridRef.current?.setActiveCell({ col: Math.min(cell.col, cols - 1), row: Math.min(cell.row, rows - 1) })
    })
    return () => cancelAnimationFrame(id)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
}
